import styles from "./ReferenceCPs/CVs.module.css";

export let ReferenceCPStatus = {
    "created": {
        "code": "created",
        "label": "Created by HR",
        "location": process.env.REACT_APP_CREATED_FOLDER,
        "style": styles.whiteC,
    },
    "toBeCompleted": {
        "code": "toBECompleted",
        "label": "To be treated by consultant",
        "location": process.env.REACT_APP_TO_BE_COMPLETED_FOLDER,
        "style": styles.orangeC,
    },
    "toBeValidated": {
        "code": "toBeValidated",
        "label": "Waiting for validation by HR",
        "location": process.env.REACT_APP_TO_BE_VALIDATED_FOLDER,
        "style": styles.DarkRedC,
    },
    "validated": {
        "code": "validated",
        "label": "Valid",
        "location": process.env.REACT_APP_VALIDATED_FOLDER,
        "style": styles.greenC,
    },
    "inValidated": {
        "code": "inValidated",
        "label": "Invalid",
        "location": process.env.REACT_APP_INVALIDATED_FOLDER,
        "style": styles.redC,
    },
}